import _, { prop } from "lodash/fp";
import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom"; 
import {Checkbox, ControlLabel, FormControl, Table} from "react-bootstrap";
import {sleep} from "../../utilities/random"
import { useTranslation } from 'react-i18next';
import Properties from "../Signtask/Properties";

export const SignTaskList = (props) => {
    const [query, setQuery] = useState(props.initialSearchParams);

    const [signTasks, setSignTasks] = useState([]);
    const { t } = useTranslation();

    let ignore = false;
    const location = "api/signtask";
    const locationBase = /^https?:\/\//i.test(location) ? "" : window.location.origin;
    let url = new URL(location, locationBase);
    for (let [key, value] of Object.entries(query)) {
        if (value !== null)
            url.searchParams.append(key, value);
    }

    useEffect(()=> {
        setSignTasks([]);
        (async function () {
            try {
                await sleep(200);
                if (ignore) return; 
                const response = await fetch(url);
                const signTasks = await response.json();
                if (ignore) return;
                setSignTasks(signTasks);
            } catch (error) {
                console.error(error);
            }
        })();
        return () => ignore = true;
    }, [query]);
    
    const ddStyle = {
        marginTop: '5px',
        float: 'right'
    };

    return (
        <React.Fragment>
            <form>
                <FormControl type="text" placeholder={t("list_signtask_ssn_placeholder")}
                             value={query.customerNumber} onChange={event => setQuery({...query, customerNumber: event.target.value})}/>
                <FormControl type="text" placeholder={t("list_signtask_referance_placeholder")}
                             value={query.applicationNumber} onChange={event => setQuery({...query, applicationNumber: event.target.value})}/>
                <FormControl type="text" placeholder="toDate (format: yyyy-MM-dd)"
                    value={query.createdToDate} onChange={event => setQuery({ ...query, createdToDate: event.target.value })} />
                <FormControl type="text" placeholder={t("list_signtask_type_heading")}
                    value={query.signTaskTypeName} onChange={event => setQuery({ ...query, signTaskTypeName: event.target.value })} />
                <ControlLabel style={{margin: '0 1rem 1rem 0'}}>{t("list_signtask_status")}:</ControlLabel>
                <Checkbox inline checked={query.unsigned}
                          onChange={event => setQuery({...query, unsigned: event.target.checked})}>{t("list_signtask_status_not_signed")}</Checkbox>
                <Checkbox inline checked={query.signed}
                          onChange={event => setQuery({...query, signed: event.target.checked})}>{t("list_signtask_status_signed")}</Checkbox>
                <Checkbox inline checked={query.rejected}
                          onChange={event => setQuery({...query, rejected: event.target.checked})}>{t("list_signtask_status_rejected")}</Checkbox>
                <Checkbox inline checked={query.archived}
                          onChange={event => setQuery({...query, archived: event.target.checked})}>{t("list_signtask_status_archived")}</Checkbox>
                <Checkbox inline checked={query.deactivated}
                          onChange={event => setQuery({...query, deactivated: event.target.checked})}>{t("list_signtask_status_deactivated")}</Checkbox>
                <select style={ddStyle} value={query.pageSize} onChange={event => setQuery({...query, pageSize: event.target.value})}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                </select>
            </form>
            
            <Table striped bordered condensed hover id="ListSigntasks">
                <thead>
                <tr>
                    <th>{t("list_signtask_signers_heading")}</th>
                    <th>{t("list_signtask_documents_heading")}</th>
                    <th>{t("list_signtask_referance_heading")}</th>
                    <th>{t("list_signtask_type_heading")}</th>
                    <th>{t("list_signtask_created_heading")}</th>
                    <th>{t("list_signtask_completed_heading")}</th>
                    <th>{t("list_signtask_archive_heading")}</th>
                </tr>
                </thead>
                <tbody>
                    {Object.values(signTasks.elements ? signTasks.elements:[]).map(x => SignTaskListElement(x))}
                </tbody>
            </Table>
        </React.Fragment>
    )
};

const SignTaskListElement = (signTask) => {
    let history = useHistory();
    let createdDate = new Date(signTask.createdDate);
    let completedDate = new Date(signTask.completionDate);
    let createdDateString = `${createdDate.getDate().toString().padStart(2, '0')}.${(createdDate.getMonth()+1).toString().padStart(2,'0')}.${createdDate.getFullYear()}`;
    let completedDateString = completedDate.getFullYear() > 1 ? `${completedDate.getDate().toString().padStart(2, '0')}.${(completedDate.getMonth()+1).toString().padStart(2,'0')}.${completedDate.getFullYear()}` : '';

    const handleTdClick = (e) => {
        e.stopPropagation();
      };

    return (<tr key={signTask.id} onClick={() => history.push(`/sign-task/${signTask.id}`)} style={{cursor: "pointer"}} >
        <td>{_.values(signTask.signers).map(signer => `${signer.name} (${signer.ssn})`).join(", ")}</td>
        <td>{_.values(signTask.documents).map(document => document.title).join(", ")}</td>
        <td>{signTask.reference}</td>
        <td>{signTask.signTaskType.name}</td>
        <td>{createdDateString}</td>
        <td>{completedDateString}</td>
        <td onClick={handleTdClick}>
            {
                signTask.status === 'Fullført' && (<Properties signtask={signTask} archive={true} />)
            }
        </td>
    </tr>); 
};